export const NAME = 'caresheets';


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/constants.js
 **/